import { Link } from "react-router-dom";
import React from "react";
import "../styles/PDFDataIDP.css";

const idpCapabilities = [
  {
    title: "PDF Data Extraction",
    description: "Extract useful information from structured and semi-structured PDF documents.",
    image: "https://images.unsplash.com/photo-1568667256549-094345857637?auto=format&fit=crop&w=900&q=85",
    alt: "Digital documents ready for data extraction",
  },
  {
    title: "OCR Processing",
    description: "Convert scanned documents and image-based files into searchable digital information.",
    image: "https://images.unsplash.com/photo-1586281380349-632531db7ed4?auto=format&fit=crop&w=900&q=85",
    alt: "Scanned paperwork prepared for OCR processing",
  },
  {
    title: "Document Classification",
    description: "Identify and organize documents based on their type, content and business purpose.",
    image: "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=900&q=85",
    alt: "Documents being reviewed and categorized",
  },
  {
    title: "Structured Output",
    description: "Transform extracted information into organized datasets suitable for business applications.",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=900&q=85",
    alt: "Structured financial information in a report",
  },
];

const PDFDataIDP = () => {
  return (
    <div className="pdf-page">

      {/* 1. Hero */}
      <section className="pdf-hero">
        <div className="pdf-content">
          <span>DATA SERVICE 03</span>

          <h1>PDF Data Collection & IDP</h1>

          <p>
            Convert documents, PDFs and scanned files into structured
            digital information using intelligent document processing
            workflows.
          </p>
        </div>

        <div className="pdf-image">
          <img
            src="https://images.unsplash.com/photo-1586953208448-b95a79798f07?auto=format&fit=crop&w=1200&q=90"
            alt="PDF Data Processing"
          />
        </div>
      </section>

      {/* 2. Capabilities */}
      <section className="pdf-capabilities">
        <h2>Intelligent Document Processing</h2>

        <div className="pdf-grid">
          {idpCapabilities.map((capability) => (
            <article key={capability.title}>
              <img src={capability.image} alt={capability.alt} loading="lazy" />
              <div className="pdf-card-content">
                <h3>{capability.title}</h3>
                <p>{capability.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* 3. Process */}
      <section className="pdf-process">
        <h2>How It Works</h2>

        <div className="pdf-flow">
          <div>PDF / Document</div>
          <div>OCR & Extraction</div>
          <div>Validation</div>
          <div>Structured Data</div>
        </div>
      </section>

      {/* 4. CTA */}
      <section className="pdf-cta">
        <h2>Make Your Documents Work Smarter</h2>
        <p>
          Reduce manual document processing and unlock valuable
          information hidden inside your files.
        </p>

        <Link to="/contact">Explore IDP Solutions →</Link>
      </section>

    </div>
  );
};

export default PDFDataIDP;